// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"bcdeb893","117":"205d16b4","433":"5989d631","460":"663825b3","505":"83d58640","594":"663825b3","647":"e2bbab1d","702":"d4980b32","705":"663825b3","715":"ddca36f9"}[chunkId] + ".chunk.css";
};